import script from "./AddressEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressEntry.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__